(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-concept-subscribe"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nura-subscribe]').forEach((section) => {
    const frequencyButtons = section.querySelectorAll('[data-frequency]');
    const frequencyOutput = section.querySelector('[data-frequency-output]');
    frequencyButtons.forEach((button) => button.addEventListener('click', () => {
      frequencyButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      if (frequencyOutput) frequencyOutput.textContent = button.dataset.frequency;
    }));
    const range = section.querySelector('[data-saving-range]');
    if (!range) return;
    const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    const updateSavings = () => {
      const monthly = Number(range.value);
      const annual = monthly * 12;
      section.querySelector('[data-monthly-output]').textContent = currency.format(monthly);
      section.querySelector('[data-one-time-output]').textContent = currency.format(annual);
      section.querySelector('[data-subscription-output]').textContent = currency.format(annual * 0.8);
      section.querySelector('[data-saving-output]').textContent = currency.format(annual * 0.2);
    };
    range.addEventListener('input', updateSavings);
    updateSavings();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-editorial-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nura-editorial-page')) {
    class NuraEditorialPage extends HTMLElement {
      connectedCallback() {
        document.documentElement.classList.add('nura-motion-ready');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const items = this.querySelectorAll('[data-reveal]');
        if (reducedMotion || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
        } else {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
          items.forEach((item) => observer.observe(item));
        }
        if (this.querySelector('[data-guide-success]')) {
          try { sessionStorage.setItem('nura_guide_requested_v1', String(Date.now())); } catch (error) { void error; }
        }
        const form = this.querySelector('.nep-form');
        if (form) {
          form.addEventListener('submit', (event) => {
            if (form.querySelector('[data-honeypot]').value) {
              event.preventDefault();
              return;
            }
          });
        }
        try { sessionStorage.removeItem('nura_guide_delivery_v1'); } catch (error) { void error; }
      }
    }
    customElements.define('nura-editorial-page', NuraEditorialPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-prelaunch"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nura-prelaunch')){customElements.define('nura-prelaunch',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.openQuiz=()=>{document.body.classList.add('nura-prelaunch-quiz');document.querySelector('nura-pattern-quiz')?.scrollIntoView();};this.closeQuiz=()=>{document.body.classList.remove('nura-prelaunch-quiz');};this.hashHandler=()=>{if(location.hash==='#nura-pattern-quiz'&&this.querySelector('[data-npl-success]'))this.openQuiz();else this.closeQuiz();};window.addEventListener('hashchange',this.hashHandler);this.querySelector('[data-open-quiz]')?.addEventListener('click',this.openQuiz);this.hashHandler();const fallback=this.querySelector('[data-capacity-label]').textContent;const endpoint=this.dataset.counterUrl;if(endpoint){this.updateCount=async()=>{try{const res=await fetch(endpoint,{credentials:'omit',signal:AbortSignal.timeout(7000)});if(!res.ok)throw Error();const data=await res.json();if(!Number.isInteger(data.joined)||data.joined<0||!Number.isFinite(Date.parse(data.updated_at))||Date.now()-Date.parse(data.updated_at)>300000||Date.parse(data.updated_at)-Date.now()>60000)throw Error();const capacity=Number(this.dataset.capacity);const remaining=Math.max(0,capacity-data.joined);this.querySelector('[data-capacity-label]').textContent=`${remaining.toLocaleString()} of ${capacity.toLocaleString()} places remaining`;const progress=this.querySelector('[data-capacity-progress]');progress.value=Math.min(capacity,data.joined);progress.hidden=false;}catch(e){this.querySelector('[data-capacity-progress]').hidden=true;this.querySelector('[data-capacity-label]').textContent=fallback;}};this.updateCount();this.timer=setInterval(()=>{if(!document.hidden)this.updateCount();},30000);}}
disconnectedCallback(){window.removeEventListener('hashchange',this.hashHandler);clearInterval(this.timer);}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nura-pattern-quiz')) {
    class NuraPatternQuiz extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.copy = JSON.parse(this.querySelector('[data-quiz-translations]').textContent);
        this.questionIndex = 0;
        this.answers = Array(7).fill(null);
        this.storageKey = 'nura_quiz_result_v2';
        this.knownTypes = ['sleep', 'mental', 'emotional', 'body', 'whole'];
        this.querySelector('[data-start]').hidden = false;
        this.querySelector('[data-start]').addEventListener('click', () => this.start());
        this.querySelector('[data-retake]').addEventListener('click', () => this.start());
        this.querySelector('[data-close]').addEventListener('click', () => this.showScreen('intro'));
        this.querySelector('[data-back]').addEventListener('click', () => {
          clearTimeout(this.advanceTimer);
          if (this.questionIndex > 0) {
            this.questionIndex -= 1;
            this.renderQuestion();
          } else {
            this.showScreen('intro');
          }
        });
        this.querySelector('[data-question-form]').addEventListener('submit', (event) => {
          event.preventDefault();
          this.advance();
        });
        this.restoreResult();
        this.startFromHash = () => {
          if (window.location.hash === '#nura-pattern-quiz' && !this.readResult()) {
            this.start();
          }
        };
        window.addEventListener('hashchange', this.startFromHash);
        this.startFromHash();
      }

      disconnectedCallback() {
        clearTimeout(this.advanceTimer);
        if (this.startFromHash) window.removeEventListener('hashchange', this.startFromHash);
      }

      advance() {
        clearTimeout(this.advanceTimer);
        if (this.answers[this.questionIndex] === null) return;
        if (this.questionIndex < 6) {
          this.questionIndex += 1;
          this.renderQuestion();
        } else {
          const type = this.getResultType(this.answers);
          const record = { type, state: 'confirmed', createdAt: Date.now() };
          if (!this.storeResult(record)) {
            this.showStorageError(this.copy.ui.storage_error);
            return;
          }
          this.renderResult(type);
        }
      }

      start() {
        clearTimeout(this.advanceTimer);
        this.answers = Array(7).fill(null);
        this.questionIndex = 0;
        this.clearResult();
        this.querySelector('[data-storage-error]').hidden = true;
        this.showScreen('questions');
        this.renderQuestion();
      }

      showScreen(name) {
        this.querySelectorAll('[data-screen]').forEach((screen) => {
          screen.hidden = screen.dataset.screen !== name;
        });
        const screen = this.querySelector('[data-screen="' + name + '"]');
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && typeof screen.animate === 'function') {
          screen.animate(
            [
              { opacity: 0, transform: 'translateY(14px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            { duration: 420, easing: 'cubic-bezier(.22,.8,.22,1)' }
          );
        }
        const heading = screen.querySelector('[tabindex="-1"]');
        if (heading) heading.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }

      renderQuestion() {
        const question = this.copy.questions[this.questionIndex];
        const count = this.copy.ui.count.replace('__CURRENT__', String(this.questionIndex + 1)).replace('__TOTAL__', '7');
        this.querySelector('[data-step]').textContent = count;
        this.querySelector('[data-progress]').value = this.questionIndex;
        this.querySelector('[data-question-label]').textContent = this.copy.ui.question + ' ' + String(this.questionIndex + 1).padStart(2, '0');
        const title = this.querySelector('[data-question-title]');
        title.textContent = question.title;
        this.querySelector('[data-question-detail]').textContent = question.detail;
        this.querySelector('[data-question-help]').textContent = (this.questionIndex < 4 ? this.copy.ui.recent + ' ' : '') + this.copy.ui.help;
        const container = this.querySelector('[data-answers]');
        container.replaceChildren();
        const options = this.questionIndex < 4 ? this.copy.frequency : question.answers.map((label) => ({ label }));
        options.forEach((option, index) => {
          const label = document.createElement('label');
          label.className = 'nq-answer';
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'nq_choice_' + this.dataset.sectionId;
          radio.value = String(index);
          radio.checked = this.answers[this.questionIndex] === index;
          radio.required = true;
          radio.addEventListener('change', () => {
            const selectedQuestion = this.questionIndex;
            this.answers[selectedQuestion] = index;
            this.querySelector('[data-next]').disabled = false;
            clearTimeout(this.advanceTimer);
            const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
            this.advanceTimer = setTimeout(() => {
              if (this.questionIndex === selectedQuestion && this.answers[selectedQuestion] === index) this.advance();
            }, delay);
          });
          const text = document.createElement('span');
          text.className = 'nq-answer-label';
          text.textContent = option.label;
          label.append(radio, text);
          if (option.detail) {
            const detail = document.createElement('span');
            detail.className = 'nq-answer-detail';
            detail.textContent = option.detail;
            label.append(detail);
          }
          container.append(label);
        });
        this.querySelector('[data-next]').disabled = this.answers[this.questionIndex] === null;
        this.querySelector('[data-next-label]').textContent = this.questionIndex === 6 ? this.copy.ui.finish : this.copy.ui.next;
        title.focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }

      getResultType(answers) {
        if (!Array.isArray(answers) || answers.length !== 7 || answers.some((answer) => !Number.isInteger(answer))) return 'whole';
        const maxOptions = [5, 5, 5, 5, 6, 6, 5];
        if (answers.some((answer, index) => answer < 0 || answer >= maxOptions[index])) return 'whole';
        const types = ['sleep', 'mental', 'emotional', 'body'];
        const frequencyWeights = [3, 2, 1, 0, 0];
        const baseline = answers.slice(0, 4).map((answer) => frequencyWeights[answer]);
        const scores = baseline.map((score, index) => ({
          type: types[index],
          baseline: score,
          score: score + (answers[4] === index ? 2 : 0) + (answers[5] === index ? 1 : 0)
        })).sort((a, b) => b.score - a.score);
        const first = scores[0];
        const second = scores[1];
        if (answers[6] === 0 || answers[6] === 4 || answers[4] >= 4) return 'whole';
        if (first.baseline < 2 || first.score < 4 || first.score - second.score < 2) return 'whole';
        return first.type;
      }

      storeResult(record) {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify(record));
          return true;
        } catch (error) {
          return false;
        }
      }

      readResult() {
        try {
          const record = JSON.parse(sessionStorage.getItem(this.storageKey));
          const now = Date.now();
          if (!record || !this.knownTypes.includes(record.type) || !['pending', 'confirmed'].includes(record.state) || !Number.isFinite(record.createdAt) || now - record.createdAt > 4 * 60 * 60 * 1000 || record.createdAt > now) return null;
          return record;
        } catch (error) {
          return null;
        }
      }

      clearResult() {
        try {
          sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          return;
        }
      }

      restoreResult() {
        const record = this.readResult();
        if (record) {
          record.state = 'confirmed';
          this.storeResult(record);
          this.renderResult(record.type);
        }
      }

      showStorageError(message) {
        const error = this.querySelector('[data-storage-error]');
        error.textContent = message;
        error.hidden = false;
      }

      renderResult(type) {
        const result = this.copy.results[type];
        if (!result) return;
        this.querySelector('[data-result-hero]').dataset.pattern = type;
        ['name', 'tagline', 'title', 'body', 'difference', 'reflection'].forEach((key) => {
          this.querySelector('[data-result-' + key + ']').textContent = result[key];
        });
        ['one', 'two', 'three'].forEach((word, index) => {
          this.querySelector('[data-result-step-title="' + (index + 1) + '"]').textContent = result['step_' + word + '_title'];
          this.querySelector('[data-result-step="' + (index + 1) + '"]').textContent = result['step_' + word];
        });
        this.querySelector('[data-confirmation]').textContent = this.copy.ui.ready;
        this.showScreen('result');
      }
    }
    customElements.define('nura-pattern-quiz', NuraPatternQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
